import { IFarmResponse } from '../../../structures/interfaces/Clients';

export const BuildFarmsSlug = (farms: IFarmResponse[]): IFarmResponse[] => {
  return farms?.map(farm => ({
    ...farm,
    slug: `${farm.name} ${farm.stateRegistration} ${farm.address} ${farm.documentNumberCnpj}`.toLowerCase(),
  }));
};
